import { FC, memo, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface ITcDivider {
  className?: string;
  orientation?: string;
  children?: ReactNode;
}

const TcDevider: FC<ITcDivider> = ({ className, orientation = 'right', children, ...props }) => {
  return (
    <div className={twMerge(`flex items-center  mb-2 ${className ? className : 'mt-8'} `)} {...props}>
      {orientation !== 'right' && <hr className='w-full' />}
      {children ? (
        <h4 className={` ${orientation === 'right' && 'ml-4'} ${orientation === 'left' && 'mr-4'} ${orientation === 'center' && 'mx-4'}  whitespace-nowrap text-t-primary-color`}>
          {children}
        </h4>
      ) : (
        <></>
      )}
      {orientation !== 'left' && <hr className='w-full' />}
    </div>
  );
};

export default memo(TcDevider);
